/**
 * The browser's IANA time zone (`Europe/Vilnius`), which each sign-in sends so the account keeps
 * the user's local time (spec docs/specs/platform/journey.md, decision 1.8). The server keeps a
 * name of the IANA database and drops anything else, so a sign-in never fails over it; null
 * where the browser names none, which keeps the last one the account had.
 */
export function browserTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}
